(() => {
  const dialog = document.getElementById('licheni-eu-legal-guarantee');
  if (!dialog) return;
  let invoker;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-guarantee-open]');
    if (opener && typeof dialog.showModal === 'function') {
      event.preventDefault();
      invoker = opener;
      if (!dialog.open) dialog.showModal();
      return;
    }
    if (event.target.closest('[data-guarantee-close]')) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (document.querySelector('dialog[open]')) document.documentElement.style.overflow = 'hidden';
    if (invoker && invoker.isConnected) invoker.focus();
  });
})();
